import { useStaticQuery, graphql } from 'gatsby';

export default (): GatsbyTypes.AllMediaItemsQuery['allWpMediaItem']['nodes'] | [] => {
  const result = useStaticQuery<GatsbyTypes.AllMediaItemsQuery>(graphql`
    query AllMediaItems {
      allWpMediaItem {
        nodes {
          databaseId
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 450
                height: 300
              )
            }
          }
        }
      }
    }
  `);
  return result?.allWpMediaItem?.nodes || [];
};
